import { useNavigate } from "@tanstack/react-router"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useCreateCustomerMutation } from "modules/customers/hooks/useCreateCustomerMutation"
import { useTranslation } from "react-i18next"
import { CustomerListSearchSchema } from "routes/_base/_auth/customers/list/route"
import { UpsertCustomerBodySchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { CustomerForm } from "./CustomerForm"

export const CustomerCreator = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { mutateAsync } = useCreateCustomerMutation()

  const onOpenChange = () => {
    navigate({ to: "/customers/list", search: CustomerListSearchSchema.parse({}) })
  }

  const onSubmit = async (data: z.infer<typeof UpsertCustomerBodySchema>) => {
    await mutateAsync(data)
    toast.success(t("customers.editSuccess"))
    onOpenChange()
  }

  return (
    <Dialog onOpenChange={onOpenChange} open>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("customers.create.title")}</DialogTitle>
          <DialogDescription>{t("customers.create.description")}</DialogDescription>
        </DialogHeader>
        <CustomerForm onSubmit={onSubmit} submitCopy={t("customers.create.save")} />
      </DialogContent>
    </Dialog>
  )
}
